<template>
  <div class="history">
    <div class="bar-chart">
      <BarChart
        id="historicChartId"
        :chart-data="dataCollection"
        :options="options"
      ></BarChart>
    </div>
  </div>
</template>

<script>
import BarChart from '@/components/Charts/BarChart.js'
import { getValueByScore } from '@/directives/metricColor.js'
import { mapGetters } from 'vuex'
import colors from '@/styles/custom/_colors.scss'

export default {
  props: {
    history: {
      required: false,
      type: Array,
      default: function() {
        return []
      },
    },
  },
  components: {
    BarChart,
  },
  data: function() {
    return {
      currentLabel: {},
      inicialClick: true,
    }
  },
  methods: {
    scoreLabel: function(index) {
      return (
        this.resources.page.reports.engagement.overall.scoreBar +
        (this.history[index].score !== null ? this.history[index].score : 'N/A')
      )
    },
    scoreColor: function(score) {
      const valueColors = {
        low: colors['metric-low'],
        medium: colors['metric-medium'],
        high: colors['metric-high'],
        blank: colors['metric-blank'],
      }

      return score
        ? getValueByScore(score, valueColors)
        : 'rgba(246,247,253,0.8)'
    },
  },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),

    dataCollection: function() {
      const collection = {
        labels: this.history.map(h => h.time.slice(0, 3)),
        datasets: [
          {
            backgroundColor: this.history.map(h => this.scoreColor(h.score)),
            data: this.history.map(h => (h.score ? h.score : 10)),
            borderColor: 'rgba(0,0,0,0)',
            borderWidth: '15',
          },
        ],
      }
      return collection
    },
    options: function() {
      return {
        cornerRadius: 40,
        borderDashOffset: 3,
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          callbacks: {
            label: tooltipItems => {
              return this.scoreLabel(tooltipItems.index)
            },
            title: tooltipItems => {
              return this.history[tooltipItems[0].index].time
            },
          },
        },
        onClick: this.chartClick,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              gridLines: {
                display: false,
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                max: 10,
              },
              gridLines: {
                display: false,
                color: 'rgba(0, 0, 0, 0)',
              },
            },
          ],
        },
      }
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

.history {
  flex-grow: 1;
  padding: 30px 10px 20px 30px;
  max-width: 600px;

  @media (max-width: 767px) {
    padding: 10px 20px;
  }
}

#bar-chart {
  position: relative;
  margin: auto;
  height: 250px;
  max-width: 100%;
  @media (max-width: 768px) {
    height: 190px;
  }
}
</style>
